var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('custom-time-picker',{staticClass:"text-input",attrs:{"value":_vm.project.onSiteStartTime,"label":"On-site start time","disabled":_vm.project.isArchived},on:{"input":_vm.saveProjectStartTime}})}
var staticRenderFns = []

export { render, staticRenderFns }